<template>
  <div class="blind-window-item" ref="item">
    <div class="blind-window-item-container-left">
      <div class="blind-window-item-container-right">
        <div class="blind-window-item-container">
          <div class="blind-window-item-background">
            <slot name="background" />
          </div>
          <div class="blind-window-item-contents">
            <slot name="contents" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup></script>

<style lang="scss" scoped>
.blind-window-item {
  --transition: transform 0.25s ease-out;
  transition: var(--transition);
  position: relative;
  overflow: hidden;
  &.blind-enter,
  &.blind-leave {
    overflow: visible;
  }

  .blind-window-item-container-left,
  .blind-window-item-container-right {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    transition: var(--transition);
    overflow: hidden;
    border-radius: 0.5rem;
  }
  .blind-window-item-container {
    width: 100%;
    height: 100%;
    transition: var(--transition);
  }

  &.blind-enter .blind-window-item-contents {
    opacity: 1;
  }

  .blind-window-item-contents {
    opacity: 0;
    transition: opacity 0.25s linear 0.1s;
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
  }

  .blind-window-item-background {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
  }
}
</style>
